export const phasesListKey = () => ["phases-list"];

export const phasesListParamsKey = ({ queryParams }) => [...phasesListKey(), queryParams];
